import styled from 'styled-components';
export const CircledIcon = styled.div `
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const IconWrapper = styled(CircledIcon) `
  position: relative;
  width: 5rem;
  height: 5rem;
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  margin-left: 1rem;
  &:hover {
    border-color: ${({ theme }) => theme.colors.interactive.brandColor};
    background-color: ${({ theme }) => theme.colors.interactive.secondary};
  }

  ${({ theme }) => theme.media.laptop `
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  `}

  ${({ theme }) => theme.media.laptopL `
    &:not(:last-child) {
      margin-right: 1.8rem;
    }
  `}
`;
export const NotificationAlert = styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  top: -0.5rem;
  right: -0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.interactive.critical};
`;
export const WorkHoursBadge = styled.div `
  position: absolute;
  top: -1rem;
  right: -1rem;

  display: flex;
  padding: 0 0.4rem 0.2rem 0.4rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  background: ${({ theme }) => theme.colors.interactive.secondary};
`;
//# sourceMappingURL=styles.js.map